import request from 'utils/request'

export const getMCAXS421InitRequest = () =>
  request({
    url: '/MCAXS421/init',
    method: 'post',
  })
